import { useEffect, useState } from 'react';

interface UseIsLoadingDelayedProps {
  loading: boolean;
  delay?: number;
}

export const useIsLoadingDelayed = ({
  loading,
  delay = 4000,
}: UseIsLoadingDelayedProps) => {
  const [isLoadingDelayed, setIsLoadingDelayed] = useState(false);

  useEffect(() => {
    if (!loading) return setIsLoadingDelayed(false);

    const timer = setTimeout(() => setIsLoadingDelayed(true), delay);

    return () => clearTimeout(timer);
  }, [loading, delay]);

  return isLoadingDelayed;
};
